// generated by the plop

import { NomenclatureModel, StorageLocationModel, StorageLocationTreeModel } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';

export interface StorageLocationStateModel {
  storageLocations: StorageLocationTreeModel;
  allStorageLocations: StorageLocationModel[];
  currentLocationId: string;
  loadStorageLocationsStatus: PROGRESS_STATUSES;
  goods: NomenclatureModel[];
  currentItem: NomenclatureModel;
}

export const STORAGE_LOCATION_STATE_DEFAULT: StorageLocationStateModel = {
  storageLocations: null,
  allStorageLocations: [],
  currentLocationId: null,
  loadStorageLocationsStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  goods: [],
  currentItem: null
};
